import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {areaFormat} from "@pg-mono/string-utils";
import {OfferType} from "@pg-rp/common-types";
import {getAdditionalAreasName, getKitchenTypeNameWith, getOfferTypeNameCapital, getRoomsPlural, IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {IPropertyListItemDTO} from "../types/IPropertyListItemDTO";

interface IProps {
    property: IPropertyDetailDTO | IPropertyListItemDTO;
}

export const PropertyMainInfoTexts = (props: IProps) => {
    const {property} = props;
    const additionalAreasText =
        property.additional_areas &&
        property.additional_areas.length > 0 &&
        property.additional_areas
            .map((item) => {
                const name = getAdditionalAreasName(item.type);
                if (!name) return "";

                return `${name}${item.area ? ` ${areaFormat(item.area)}` : ""}`;
            })
            .filter(Boolean)
            .join(", ");

    return (
        <>
            <Text variant="headline_5" className={mb1Style}>
                {`${property.rooms} ${getRoomsPlural(property.rooms)} `}
                {`${getKitchenTypeNameWith(property.kitchen_type)}, `}
                {property.area != null ? `${areaFormat(property.area)} ` : ""}
                {additionalAreasText ? `+ ${additionalAreasText}` : ""}
            </Text>

            <Text variant="info_txt_1" color="var(--colors-gray-800)">
                {`${property.offer.name}, `}
                {getOfferTypeNameCapital(property?.type || OfferType.FLAT)}
                {property?.type === OfferType.FLAT && property.flat_number && (
                    <>
                        {" "}
                        nr <strong>{property.flat_number}</strong>
                    </>
                )}
                {property?.type === OfferType.HOUSE && (
                    <>
                        {" "}
                        nr <strong>{property.flat_number || property.building_number}</strong>
                    </>
                )}
            </Text>

            <Text variant="info_txt_1" color="var(--colors-gray-800)">
                {property.offer.address}
            </Text>
        </>
    );
};

const mb1Style = css({
    mb: 1
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {areaFormat} from "@pg-mono/string-utils";
import {OfferType} from "@pg-rp/common-types";
import {getAdditionalAreasName, getKitchenTypeNameWith, getOfferTypeNameCapital, getRoomsPlural, IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {IPropertyListItemDTO} from "../types/IPropertyListItemDTO";

interface IProps {
    property: IPropertyDetailDTO | IPropertyListItemDTO;
}

export const PropertyMainInfoTexts = (props: IProps) => {
    const {property} = props;
    const additionalAreasText =
        property.additional_areas &&
        property.additional_areas.length > 0 &&
        property.additional_areas
            .map((item) => {
                const name = getAdditionalAreasName(item.type);
                if (!name) return "";

                return `${name}${item.area ? ` ${areaFormat(item.area)}` : ""}`;
            })
            .filter(Boolean)
            .join(", ");

    return (
        <>
            <Text variant="headline_5" className={mb1Style}>
                {`${property.rooms} ${getRoomsPlural(property.rooms)} `}
                {`${getKitchenTypeNameWith(property.kitchen_type)}, `}
                {property.area != null ? `${areaFormat(property.area)} ` : ""}
                {additionalAreasText ? `+ ${additionalAreasText}` : ""}
            </Text>

            <Text variant="info_txt_1" color="var(--colors-gray-800)">
                {`${property.offer.name}, `}
                {getOfferTypeNameCapital(property?.type || OfferType.FLAT)}
                {property?.type === OfferType.FLAT && property.flat_number && (
                    <>
                        {" "}
                        nr <strong>{property.flat_number}</strong>
                    </>
                )}
                {property?.type === OfferType.HOUSE && (
                    <>
                        {" "}
                        nr <strong>{property.flat_number || property.building_number}</strong>
                    </>
                )}
            </Text>

            <Text variant="info_txt_1" color="var(--colors-gray-800)">
                {property.offer.address}
            </Text>
        </>
    );
};

const mb1Style = css({
    mb: 1
});
